var React = require('react');

function CheckmarkGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.1,14.5c-1.1,0-1.7,0-2.8,0L39.8,53l-18-18c-1.1,0-1.7,0-2.8,0L4.8,49.1c0,1.1,0,1.7,0,2.8l33.6,33.6c1.1,0,1.7,0,2.8,0  l54-54c0-1.1,0-1.7,0-2.8L81.1,14.5z"}));
}

CheckmarkGreen.defaultProps = {"height":"100px","width":"100px","fill":"#00534a","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = CheckmarkGreen;

CheckmarkGreen.default = CheckmarkGreen;
